export default __webpack_public_path__ + "static/media/Elle_Tiffany_2021_04_211010_3.a9ac2106.gif";